// Rotas.js
import React, { useEffect, useState, createContext, useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Signin from "../pages/signin/signin";
import RecoverPass from "../pages/recoverPass/recoverPass";
import Home from "../pages/home/home";
import API_ROUTES from "../utils/endpoints";
import api from "../utils/api";

// Contexto de autenticação
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

// Componente PrivateRoute para proteger rotas
const PrivateRoute = ({ children }) => {
  const { auth } = useAuth();

  if (auth.loading) return <div>Carregando...</div>;

  return auth.logged ? children : <Navigate to="/" replace />;
};

function Rotas() {
  const [auth, setAuth] = useState({
    logged: false,
    loading: true,
    nameUser: "",
    type: "",
  });

  // Função para validar token no backend
  const validaToken = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setAuth((prev) => ({ ...prev, logged: false, loading: false }));
        return;
      }

      const { data } = await api.post(API_ROUTES.VALIDA_TOKEN);

      if (data.code === 200) {
        setAuth({
          logged: true,
          loading: false,
          nameUser: data.name,
          type: data.type,
        });
      } else {
        localStorage.removeItem("token");
        setAuth({ logged: false, loading: false, nameUser: "", type: "" });
      }
    } catch (err) {
      console.error("Erro ao validar token:", err);
      localStorage.removeItem("token");
      setAuth({ logged: false, loading: false, nameUser: "", type: "" });
    }
  };

  // Executa validação ao iniciar o app
  useEffect(() => {
    validaToken();

    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (!token) return;

      // Se usar token com expires:
      // const tokenObj = JSON.parse(token);
      // if (Date.now() >= tokenObj.expires) {
      //   localStorage.removeItem("token");
      //   setAuth((prev) => ({ ...prev, logged: false }));
      // }
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      <Router>
        <Routes>
          <Route path="/" element={<Signin />} />
          <Route path="/recoverPass" element={<RecoverPass />} />
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default Rotas;
